module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6NtUh"))).then(() => parcelRequire('dPAKA'));